<template>
  <div class="address_row-inside">
    <v-col cols="1" class="actions_col">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            @click.stop="addressSave()"
            class="mr-2"
            color="gray darken-2"
          >
            <v-icon color="green" small>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.customers.actions.save }}</span>
      </v-tooltip>
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            @click.stop="$emit('closed', true)"
            class="mr-2"
            color="gray darken-2"
          >
            <v-icon small color="red">mdi-close</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.orders.view.close }}</span>
      </v-tooltip>
    </v-col>
    <v-col cols="11" class="address_col">
      <v-form
        :ref="`addressSaveForm${index}`"
        v-model="addressValid"
        lazy-validation
      >
        <v-row class="editAddressRow">
          <v-col cols="4" class="editAddressCol">
            <v-text-field
              :label="lang.orders.new.customer.cep"
              v-model="address.cep"
              :rules="lang.customers.edit.rules.cepRules"
              v-mask="cep_mask"
              :change="loadCep"
              :loading="editingLoading"
              :disabled="editingLoading"
              autocomplete="new-password"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="editAddressCol">
            <v-text-field
              :label="lang.orders.new.customer.address"
              v-model="address.address"
              :rules="lang.customers.edit.rules.addressRules"
              :loading="editingLoading"
              :disabled="editingLoading"
              autocomplete="new-password"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="editAddressCol">
            <v-text-field
              :label="lang.orders.new.customer.address_number"
              v-model="address.num"
              :rules="lang.customers.edit.rules.numRules"
              :ref="`addressNum${index}`"
              autocomplete="new-password"
              filled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="editAddressRow">
          <v-col cols="3" class="editAddressCol">
            <v-text-field
              :label="lang.orders.new.customer.com"
              v-model="address.comp"
              :rules="lang.customers.edit.rules.compRules"
              autocomplete="new-password"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="editAddressCol">
            <v-text-field
              :label="lang.orders.new.customer.neighborhood"
              v-model="address.neighborhood"
              :rules="lang.customers.edit.rules.neighborhoodRules"
              :loading="editingLoading"
              :disabled="editingLoading"
              autocomplete="new-password"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="editAddressCol">
            <v-select
              :items="states"
              v-model="address.state"
              :label="lang.orders.new.customer.state"
              :loading="editingLoading"
              :disabled="editingLoading"
              filled
            ></v-select>
          </v-col>
          <v-col cols="3" class="editAddressCol">
            <v-select
              :items="cities"
              v-model="address.city"
              :label="lang.orders.new.customer.city"
              :no-data-text="lang.orders.new.customer.no_state"
              :loading="editingLoading"
              :disabled="editingLoading"
              filled
            ></v-select>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import addressesApi from '../../mixins/addresses_api'

export default {
  mixins: [ appdata, addressesApi ],
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      address: { ...this.value } || {}
    }
  },
  watch: {
    value (newVal) {
      console.log('toggle watch value')
      this.address = { ...newVal }
    }
  }
}
</script>
